import React from "react";
import AppHeader from '../../components/Header/Header';
import AppLayout from '../../components/layout';
import BannerSection from '../../components/ui/BannerSection';
import JornadaCientificaMenu from '../../components/ui/AreaCientifica';
import SectionHeading from '../../components/SectionHeading';
import BreadcrumbNav from '../../components/ui/BreadcrumbNav';



const caminho = [
  { label: 'Home', href: '/', icon: 'bi bi-house-door' },
  { label: 'Área Científica' },
  { label: 'Jornada Científica', href: '/investigacao/jornada' },
  { label: 'Taxa de Participação' }
];

function JornadaCientifica() {

    return (
        <>
        <header id='header'>
        <AppHeader />
        </header>
        <BannerSection
                title="Taxa de Participação"
                subtitle="Bem-vindo à Jornada Científica do ISP-Atlântida"
                description={`Participe da jornada científica do ISP-Atlântida, um evento anual que promove a pesquisa e o desenvolvimento científico na instituição. Conheça os trabalhos de pesquisa realizados por alunos e professores, além de palestras e debates sobre temas relevantes para a comunidade acadêmica.`}
                backgroundImage={require('../../assets/JorBanner.jpg')}
                backgroundId="instituition-Banner"
            />
            <BreadcrumbNav items={caminho} />
            <main className="px-3 px-md-5 px-xl-5 px-xxl-5 py-2">
            <br />
            <div className="row flex-row-reverse">
                                <div className="col-12 col-md-4 col-lg-3 col-xl-2 col-xxl-2 menu-color">
                    <JornadaCientificaMenu />
                </div>
                <div className="col-12 col-md-8 col-lg-9 col-xl-10 col-xxl-10">
                <br />
                <div className="details-magazine" id='detalhes'>
                    <p className="f-reg">
                      <SectionHeading title="Taxa de Participação" />
                    <br />
                    A participação na nossa Jornada Científica oferece uma oportunidade única de imersão em um evento de alto nível, com acesso a palestras, workshops, apresentações de pesquisas e muito mais. Para garantir a sua presença e a qualidade da experiência de todos os envolvidos, estabelecemos uma taxa de participação que cobre os custos de organização, infraestrutura e materiais.
                     <br /><br />

                    <h4 style={{color:'#198754'}}><b>Valores de Taxa</b></h4>
                    Estudantes: <b>500,00kz</b> <br />
                    Profissionais e Pesquisadores: <b>1.000,00kz</b> <br />
                    Participação para o público: <b>2.500,00kz</b> <br />
                    <br />
                     Sua inscrição inclui acesso completo a todas as atividades da jornada, além de materiais exclusivos, certificados de participação e a possibilidade de network com grandes nomes da ciência e pesquisa. Aproveite essa oportunidade para expandir seu conhecimento, compartilhar suas pesquisas e fazer parte de uma comunidade científica crescente e inovadora!
                    <br /><br />
                    </p>
                    <br />
                </div>
                <br /><br />
                </div>
            </div>
            <br />
            <br />
            <br />
            <br />
            <br />
            </main>
        <AppLayout />
        </>
       
    );
}

export default JornadaCientifica;